import React, { PureComponent } from 'react';
import { BarChart, Bar, ResponsiveContainer,XAxis,YAxis,Tooltip,LabelList } from 'recharts';

const data = [
  {
    name: '2 Mix',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: '3 Mix',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: '4 Mix',
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: '5 Mix',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: '6 Mix',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: '7 Mix',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: '8 Mix',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

export default class TinyBarChartPanel extends PureComponent {
  static demoUrl = 'https://codesandbox.io/p/sandbox/tiny-bar-chart-xzyy8g';

  render() {
    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                layout="vertical"
                data={data}
                margin={{ top: 20, right: 30, left: 40, bottom: 0 }}
            >
                <XAxis type="number" hide={true}/>
                <YAxis 
                dataKey="name" 
                type="category" 
                tick={{
                    fontSize: 12,
                    fill: "#000"
                  }}
                />
                 <Tooltip cursor={{ fill: 'transparent' }}/>
                <Bar dataKey="uv" fill="#365f94" barSize={30}>
                    <LabelList
                        dataKey="uv"
                        position="right"
                        style={{
                            fill: '#000',
                            fontSize: 12
                        }} />
                </Bar>   
            </BarChart>
        </ResponsiveContainer>
    );
  }
}
